

document.addEventListener('DOMContentLoaded', function() {

	if ( document.querySelector('.accordion') ) {
		import('./components/accordion/accordion').then( c => new c.Accordion( document.querySelector('.accordion') ) );
	}

}, false);


